import reqest from "../common/reqest";


/**
 * 获取用户信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function getUserInfo(data) {
  return reqest.send("/Login/User_Details",data)
}
export function findUserDetails(data) {
  return reqest.send("/Login/findUserDetails",data)
}

/**
 * 修改用户信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function updateUserInfo(data) {
  return reqest.send("/Login/Update_User_Details",data)
}

/**
 * 修改企业手机号
 * @param data
 * @returns {Promise<unknown>}
 */
export function updateTel(data) {
  return reqest.send("/login/updatePhone",data)
}

/**
 * 获取用户余额
 * @param data
 * @returns {Promise<unknown>}
 */
export function getUserBalance(data) {
  return reqest.send("/Order/get_user_balance",data)
}
/**
 * 获取区域信息
 */
export function getAllArea(data) {
  return reqest.send("/index/getAllArea",data)
}
/**
 * 获取区域信息
 */
export function delUserFile(data) {
  return reqest.send("/Publicother/delUserFile",data)
}

